import getLogger from '@ignitesales/logger-es';

const logger = getLogger();

let pages = [
  {
    type: 'landing'
  },
  {
    type: 'summary',
    products: {},
    answers: []
  }
];

let currentPageIndex = 0;

const wait = (ms) => {
  const time = ms || (Math.random() * 1000);
  return () => new Promise((resolve) => setTimeout(resolve, time));
};

const buildPageResolutionService = (config = {}) => {
  const {
    guideDelivery,
    guideType
  } = config;

  return {
    ready: false,
    nextPage: async (request) => {
      logger.info('entered pageResolutionService.nextPage()', { currentPageIndex, request });

      let reverse = request.reverse;

      await wait();
      switch (request.page.type) {
        case 'landing':
          reverse = false;
          break;

        case 'summary':
          reverse = true;
          break;

        default:
          break;
      }


      if (reverse) {
        currentPageIndex--;
      } else {
        currentPageIndex++;
      }

      return pages[currentPageIndex];
    },

    loadPage: async (request) => {
      logger.info('loadPage', request);
      switch (request.page.type) {
        case 'landing':
          break;

        case 'summary':
          const summaryIndex = pages.findIndex(p => p.type === 'summary');
          currentPageIndex = summaryIndex > 0 ? summaryIndex : 0;
          break;

        case 'details':
          const detailsIndex = pages.findIndex(p => p.type === 'details');
          currentPageIndex = detailsIndex > 0 ? detailsIndex : 0;
          break;

        case 'survey':
          const path = request.page.path.key;
          const page = request.page.page.key;
          const pageIndex = pages.findIndex(p => {
            return p.type === 'survey' && p.page.path.key === path && p.page.page.key === page
          });
          if (pageIndex > 0) {
            currentPageIndex = pageIndex;
          } else {
            currentPageIndex = 0;
          }
          break;

        default:
          currentPageIndex = 0;
          break;
      }

      return pages[currentPageIndex];
    },

    loadMessages: async () => {
      return {}
    },

    initializeUser: async () => {
      return {
        uuid: 'abc123',
        guideId: 100,
        guideDelivery: guideDelivery || 'online',
        guideType: guideType || 'consumer',
        assignment: {
          employee: {
            firstName: 'Bugs',
            lastName: 'Bunny'
          },
          branch: {
            name: 'Space Jam Headquarters'
          }
        }
      }
    }
  }
}

const pageResolutionService = buildPageResolutionService();

const setPages = (newPages) => {
  pages = newPages;
  if (pageResolutionService) {
    pageResolutionService.ready = true;
  }
};

export {
  pageResolutionService as default,
  pageResolutionService,
  buildPageResolutionService,
  setPages
};
